import { forwardRef, useRef, useImperativeHandle } from 'react';
import type { BannerProps, BannerCarouselHandle } from './BannerCarouselTypes';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { styled } from '@mui/material/styles';

export interface BannerCarouselProps {
  elements?: JSX.Element[];
  settings?: BannerProps;
}

const SliderWrapper = styled('div')`
  .slick-slider {
    margin-bottom: 0 !important;
  }
`;

const BannerCarousel = forwardRef<BannerCarouselHandle, BannerCarouselProps>((props, ref) => {
  const sliderRef = useRef<Slider | null>(null);

  // 외부에서 사용할 수 있는 함수들을 선언
  useImperativeHandle(ref, () => ({
    next: () => sliderRef.current?.slickNext(),
    prev: () => sliderRef.current?.slickPrev(),
  }));

  const defaultSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: false,
  };

  return (
    <SliderWrapper sx={{ width: '100%' }}>
      <Slider ref={sliderRef} {...defaultSettings} {...(props.settings || {})}>
        {props?.elements?.map((el, index) => <div key={index}>{el}</div>)}
      </Slider>
    </SliderWrapper>
  );
});

export default BannerCarousel;
